import type { MouseEvent } from 'react';

/** 3D-Tilt + Glow-Boost — portiert aus Claude DC-Export (statTiltMove/Leave). */

function fineMotionAllowed(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
    !window.matchMedia('(pointer: coarse)').matches
  );
}

export function cardTiltMove(e: MouseEvent<HTMLElement>): void {
  if (!fineMotionAllowed()) return;
  const el = e.currentTarget;
  const r = el.getBoundingClientRect();
  const px = (e.clientX - r.left) / r.width - 0.5;
  const py = (e.clientY - r.top) / r.height - 0.5;
  el.style.transform = `perspective(900px) rotateX(${(-py * 7).toFixed(2)}deg) rotateY(${(px * 7).toFixed(2)}deg) translateY(-4px)`;
  const glow = el.previousElementSibling as HTMLElement | null;
  if (glow?.classList.contains('t05-glow-card__halo')) {
    glow.style.opacity = '0.65';
  }
}

export function cardTiltLeave(e: MouseEvent<HTMLElement>): void {
  const el = e.currentTarget;
  el.style.transform = '';
  const glow = el.previousElementSibling as HTMLElement | null;
  if (glow?.classList.contains('t05-glow-card__halo')) {
    const base = glow.dataset.baseOpacity ?? '0.28';
    glow.style.opacity = base;
  }
}

/** Leichterer Tilt für Produkt-Stack-Panels (Claude ProductStack). */
export function panelTiltMove(e: MouseEvent<HTMLElement>): void {
  if (!fineMotionAllowed()) return;
  const el = e.currentTarget;
  const r = el.getBoundingClientRect();
  const px = (e.clientX - r.left) / r.width - 0.5;
  const py = (e.clientY - r.top) / r.height - 0.5;
  el.style.transform = `perspective(700px) rotateX(${(-py * 5).toFixed(2)}deg) rotateY(${(px * 5).toFixed(2)}deg)`;
}

export function panelTiltLeave(e: MouseEvent<HTMLElement>): void {
  e.currentTarget.style.transform = '';
}
